 // casting to string prevents the usage with number or symbol properties which is a very rare case.
 // but helps us to remove casting while using this function to assign value to strings, which is the case most of the time
export const propertyOf = <T>(name: keyof T): string => name as string;
